/**
 * Kaching Bundles → Dawn price + gallery sync.
 * Price: read from Kaching deal bar DOM (Lumive pattern).
 * Gallery: thumbnail click by variant media id / image URL (never setActiveMedia with wrong id).
 */
(function () {
  'use strict';

  var KACHING_ROOT = 'kaching-bundles-block, kaching-bundle';
  var KACHING_EVENTS = ['deal-bar-selected', 'variant-selected', 'variants-changed', 'items-changed'];
  var KACHING_WINDOW_EVENTS = [
    'kaching:variant-selected',
    'kaching:deal-bar-selected',
    'kaching:variants-changed',
  ];

  var syncTimer = null;
  var fetchTimer = null;
  var isSyncing = false;
  var lastGalleryKey = '';
  var kachingGalleryUserPicked = false;

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function getProductInfo() {
    return $('product-info');
  }

  function getSectionId(productInfo) {
    return productInfo.dataset.originalSection || productInfo.dataset.section;
  }

  function parseVariants(productInfo) {
    var el = document.getElementById('ProductVariantsJSON-' + getSectionId(productInfo));
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function findVariantById(productInfo, variantId) {
    var variants = parseVariants(productInfo);
    if (!variants || !variantId) return null;
    return variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
  }

  function fileKey(src) {
    if (!src) return '';
    var m = String(src).match(/\/files\/([^?#]+)/);
    return m ? decodeURIComponent(m[1]).toLowerCase() : '';
  }

  function walkShadowRoots(node, fn) {
    if (!node) return;
    fn(node);
    if (node.shadowRoot) walkShadowRoots(node.shadowRoot, fn);
    $all('*', node).forEach(function (child) {
      if (child.shadowRoot) walkShadowRoots(child.shadowRoot, fn);
    });
  }

  function queryCheckedRadioDeep(root) {
    if (!root) return null;
    if (root.querySelector) {
      var hit = root.querySelector('input[type="radio"]:checked');
      if (hit) return hit;
    }
    var nodes = $all('*', root);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].shadowRoot) {
        hit = queryCheckedRadioDeep(nodes[i].shadowRoot);
        if (hit) return hit;
      }
    }
    return null;
  }

  function getKachingBlock() {
    return $(KACHING_ROOT);
  }

  function findSelectedKachingBar(block) {
    if (!block) return null;
    var checked = queryCheckedRadioDeep(block);
    if (checked) {
      return (
        checked.closest('[class*="deal"], [class*="Deal"], [class*="bar"], label, [role="radio"]') ||
        checked.parentElement
      );
    }
    var selected = null;
    walkShadowRoots(block, function (node) {
      if (selected || !node.querySelector) return;
      selected = node.querySelector(
        '[aria-checked="true"], [aria-selected="true"], [data-selected="true"], .deal-bar--selected, .selected, .active'
      );
    });
    return selected;
  }

  function getDealBarImageSrc(block) {
    var bar = findSelectedKachingBar(block);
    if (!bar) return null;
    var img = bar.querySelector('img');
    if (img && img.src) return img.src;
    var found = null;
    walkShadowRoots(bar, function (node) {
      if (found || !node.querySelector) return;
      var inner = node.querySelector('img');
      if (inner && inner.src) found = inner.src;
    });
    return found;
  }

  function getVariantByDealIndex(productInfo) {
    var block = getKachingBlock();
    if (!block) return null;

    var radios = [];
    walkShadowRoots(block, function (node) {
      if (!node.querySelectorAll) return;
      $all('input[type="radio"]', node).forEach(function (radio) {
        if (!radio.name) return;
        var exists = radios.some(function (r) {
          return r.name === radio.name && r.value === radio.value;
        });
        if (!exists) radios.push(radio);
      });
    });

    var checked = radios.find(function (r) {
      return r.checked;
    });
    if (!checked) return null;

    var group = radios.filter(function (r) {
      return r.name === checked.name;
    });
    group.sort(function (a, b) {
      return (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
    });

    var index = group.indexOf(checked);
    var variants = parseVariants(productInfo);
    if (!variants || index < 0) return null;
    return variants[index] || null;
  }

  function resolveVariant(productInfo, event) {
    var detail = event && event.detail;
    var variantId = null;

    if (detail) {
      if (detail.variantId) variantId = detail.variantId;
      else if (detail.variant_id) variantId = detail.variant_id;
      else if (detail.variant && detail.variant.id) variantId = detail.variant.id;
    }

    var block = getKachingBlock();
    if (block) {
      var attrId = block.getAttribute('current-variant-id');
      if (attrId) variantId = attrId;
    }

    if (!variantId) {
      var input = productInfo.querySelector('product-form input[name="id"]');
      if (input && input.value) variantId = input.value;
    }

    var variant = findVariantById(productInfo, variantId);
    if (variant) return variant;

    return getVariantByDealIndex(productInfo);
  }

  /* ---------- Price sync ---------- */

  function isSaveLabel(text) {
    return text && /\b(you save|save|saving|saved)\b/i.test(String(text));
  }

  function parsePriceNumber(text) {
    if (!text) return NaN;
    var s = String(text).replace(/[^\d.,]/g, '').trim();
    if (!s) return NaN;
    if (/,\d{1,2}$/.test(s)) s = s.replace(/\./g, '').replace(',', '.');
    else s = s.replace(/,/g, '');
    return parseFloat(s);
  }

  function formatMoneyLike(referenceText, amount) {
    if (isNaN(amount)) return null;
    if (!referenceText) return String(amount);
    var useCommaDecimal = /,\d{1,2}(?:\D|$)/.test(referenceText);
    var parts = amount.toFixed(2).split('.');
    var intPart = parts[0];
    if (useCommaDecimal && intPart.length > 3) {
      intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else if (!useCommaDecimal && intPart.length > 3) {
      intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    var numStr = useCommaDecimal ? intPart + ',' + parts[1] : intPart + '.' + parts[1];
    var prefix = (referenceText.match(/^[^\d]+/) || [])[0];
    if (prefix) return prefix.trim() + numStr;
    var suffix = (referenceText.match(/[^\d]+$/) || [])[0];
    if (suffix) return numStr + suffix.trim();
    return numStr;
  }

  function looksLikePrice(text) {
    return text && text.length <= 22 && /(\$|€|£|\d+[.,]\d{2})/.test(text) && !isSaveLabel(text);
  }

  function isStruckThrough(el, root) {
    while (el && el !== root) {
      if (el.matches && el.matches('s, del, strike')) return true;
      el = el.parentElement;
    }
    return false;
  }

  function extractPriceNodes(scope) {
    if (!scope) return [];
    var nodes = [];
    $all('*', scope).forEach(function (el) {
      if (el.children.length) return;
      var text = el.textContent.trim();
      if (!looksLikePrice(text)) return;
      nodes.push({
        text: text,
        num: parsePriceNumber(text),
        strike: isStruckThrough(el, scope),
      });
    });
    return nodes;
  }

  function pricesFromNodes(nodes) {
    if (!nodes.length) return null;
    var sale = nodes.filter(function (p) {
      return !p.strike && !isNaN(p.num);
    });
    var compare = nodes.filter(function (p) {
      return p.strike && !isNaN(p.num);
    });
    var priceNode = sale[0] || nodes.find(function (p) {
      return !isNaN(p.num);
    });
    if (!priceNode) return null;
    return {
      price: priceNode.text,
      compare: compare.length ? compare[0].text : null,
      saleNum: priceNode.num,
      compareNum: compare.length ? compare[0].num : NaN,
    };
  }

  function extractPricesFromScope(scope) {
    return pricesFromNodes(extractPriceNodes(scope));
  }

  function formatCents(cents, referenceText) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return formatMoneyLike(referenceText || '$0.00', cents / 100);
  }

  function pricesFromKachingPricingObject(pricing) {
    if (!pricing || typeof pricing !== 'object') return null;

    var price = null;
    var compare = null;

    if (pricing.discountedPrice != null) {
      if (typeof pricing.discountedPrice === 'object') {
        price = pricing.discountedPrice.formatted;
      } else if (typeof pricing.discountedPrice === 'number') {
        price = formatCents(pricing.discountedPrice);
      }
    }
    if (pricing.fullPrice != null) {
      if (typeof pricing.fullPrice === 'object') {
        compare = pricing.fullPrice.formatted;
      } else if (typeof pricing.fullPrice === 'number') {
        compare = formatCents(pricing.fullPrice);
      }
    }

    if (price && looksLikePrice(String(price))) {
      return { price: String(price).trim(), compare: compare ? String(compare).trim() : null };
    }
    return null;
  }

  function pricesFromKachingDetail(detail) {
    if (!detail || typeof detail !== 'object') return null;

    var fromPricing = pricesFromKachingPricingObject(detail.pricing);
    if (fromPricing && fromPricing.price) return fromPricing;

    var price =
      detail.formattedTotalPrice ||
      detail.totalFormattedPrice ||
      detail.formattedPrice ||
      detail.priceFormatted ||
      detail.formatted_price ||
      detail.price;
    var compare =
      detail.formattedCompareAtPrice ||
      detail.compareAtPriceFormatted ||
      detail.formattedOriginalPrice ||
      detail.formattedComparePrice ||
      detail.compareAtPrice ||
      detail.originalFormattedPrice ||
      detail.formattedCompareAt;
    if (typeof price === 'number') {
      price = formatCents(price);
    }
    if (typeof compare === 'number') {
      compare = formatCents(compare);
    }
    if (price && looksLikePrice(String(price))) {
      return { price: String(price).trim(), compare: compare ? String(compare).trim() : null };
    }
    return null;
  }

  function readKachingBlockPricing(block) {
    if (!block || typeof block.pricing !== 'function') return null;
    try {
      return pricesFromKachingPricingObject(block.pricing());
    } catch (error) {
      return null;
    }
  }

  function findUpsellScope(checkbox) {
    var row =
      checkbox.closest('[class*="upsell"], [class*="Upsell"], [class*="addon"], [class*="Add-on"], [class*="add-on"]') ||
      checkbox.closest('label, [role="checkbox"], li, article, div');
    if (!row) return null;
    if (extractPriceNodes(row).length) return row;

    var parent = row.parentElement;
    for (var i = 0; i < 5 && parent; i++) {
      if (extractPriceNodes(parent).length) return parent;
      parent = parent.parentElement;
    }
    return row;
  }

  function getSelectedUpsellScopes(block) {
    var scopes = [];
    walkShadowRoots(block, function (node) {
      if (!node.querySelectorAll) return;

      $all('.kaching-bundles__upsell', node).forEach(function (row) {
        if (
          row.querySelector('.kaching-bundles__upsell__checkbox--selected') &&
          scopes.indexOf(row) === -1
        ) {
          scopes.push(row);
        }
      });

      $all('[class*="upsell"][class*="selected"], [class*="Upsell"][class*="selected"]', node).forEach(
        function (row) {
          if (scopes.indexOf(row) === -1) scopes.push(row);
        }
      );

      $all('input[type="checkbox"]:checked', node).forEach(function (checkbox) {
        var scope = findUpsellScope(checkbox);
        if (scope && scopes.indexOf(scope) === -1) scopes.push(scope);
      });
    });
    return scopes;
  }

  function extractUpsellPrices(scope) {
    if (!scope) return null;
    var priceEl = scope.querySelector('.kaching-bundles__upsell__price');
    if (priceEl) {
      var compareEl = scope.querySelector('.kaching-bundles__upsell__full-price');
      return {
        price: priceEl.textContent.trim(),
        compare: compareEl ? compareEl.textContent.trim() : null,
        saleNum: parsePriceNumber(priceEl.textContent),
        compareNum: compareEl ? parsePriceNumber(compareEl.textContent) : NaN,
      };
    }
    return extractPricesFromScope(scope);
  }

  function sumKachingPrices(basePrices, extraScopes) {
    if (!basePrices) return null;
    var totalSale = basePrices.saleNum;
    var totalCompare = basePrices.compareNum;
    var hasCompare = !isNaN(totalCompare);

    extraScopes.forEach(function (scope) {
      var upsellPrices = extractUpsellPrices(scope);
      if (!upsellPrices || isNaN(upsellPrices.saleNum)) return;
      totalSale = (isNaN(totalSale) ? 0 : totalSale) + upsellPrices.saleNum;
      if (!isNaN(upsellPrices.compareNum)) {
        totalCompare = (isNaN(totalCompare) ? 0 : totalCompare) + upsellPrices.compareNum;
        hasCompare = true;
      } else if (!isNaN(upsellPrices.saleNum)) {
        totalCompare = (isNaN(totalCompare) ? 0 : totalCompare) + upsellPrices.saleNum;
        hasCompare = true;
      }
    });

    if (isNaN(totalSale)) return basePrices;

    return {
      price: formatMoneyLike(basePrices.price, totalSale),
      compare: hasCompare ? formatMoneyLike(basePrices.compare || basePrices.price, totalCompare) : basePrices.compare,
    };
  }

  function pickBestKachingPrices(candidates) {
    var best = null;
    var bestNum = NaN;

    candidates.forEach(function (candidate) {
      if (!candidate || !candidate.price) return;
      var num = parsePriceNumber(candidate.price);
      if (!best || (!isNaN(num) && (isNaN(bestNum) || num > bestNum))) {
        best = candidate;
        bestNum = num;
      }
    });

    return best;
  }

  function readKachingPricesFromDom(block) {
    if (!block) return null;

    var bar = findSelectedKachingBar(block);
    var dealPrices = extractPricesFromScope(bar);
    if (!dealPrices || !dealPrices.price) return null;

    var upsellScopes = getSelectedUpsellScopes(block);
    if (!upsellScopes.length) {
      return { price: dealPrices.price, compare: dealPrices.compare };
    }

    return sumKachingPrices(dealPrices, upsellScopes);
  }

  function readKachingPrices(block, detail) {
    var fromBlock = readKachingBlockPricing(block);
    var fromDetail = pricesFromKachingDetail(detail);
    var fromDom = readKachingPricesFromDom(block);

    return pickBestKachingPrices([fromBlock, fromDetail, fromDom]);
  }

  function updateDawnPrices(productInfo, priceText, compareText) {
    if (!priceText) return;
    var sectionId = getSectionId(productInfo);
    var priceRoot = document.getElementById('price-' + sectionId);
    if (priceRoot) {
      var saleEl = priceRoot.querySelector('.price-item--sale');
      var regularEl = priceRoot.querySelector('.price__regular .price-item--regular');
      if (saleEl) {
        saleEl.textContent = priceText;
        var saleWrap = priceRoot.querySelector('.price__sale');
        if (saleWrap) saleWrap.style.display = '';
        var regWrap = priceRoot.querySelector('.price__regular');
        if (regWrap) regWrap.style.display = 'none';
      } else if (regularEl) {
        regularEl.textContent = priceText;
      }
      if (compareText) {
        var compareEl = priceRoot.querySelector('.price__compare-price s');
        if (compareEl) compareEl.textContent = compareText;
      }
    }

    var atcPrice = document.getElementById('ProductSubmitButtonPrice-' + sectionId);
    if (atcPrice) atcPrice.textContent = priceText;

    var atcCompare = document.getElementById('ProductSubmitButtonCompare-' + sectionId);
    if (atcCompare && compareText) {
      atcCompare.textContent = compareText;
      atcCompare.hidden = false;
    }

    updateStickyAtcPrices(sectionId, priceText, compareText);
  }

  function updateStickyAtcPrices(sectionId, priceText, compareText) {
    var stickyPriceRoot = document.getElementById('atc-price-' + sectionId);
    if (!stickyPriceRoot || !priceText) return;

    var saleEl = stickyPriceRoot.querySelector('.price-item--sale');
    var regularEl = stickyPriceRoot.querySelector('.price__regular .price-item--regular');
    if (saleEl) {
      saleEl.textContent = priceText;
      var saleWrap = stickyPriceRoot.querySelector('.price__sale');
      if (saleWrap) saleWrap.style.display = '';
      var regWrap = stickyPriceRoot.querySelector('.price__regular');
      if (regWrap) regWrap.style.display = 'none';
    } else if (regularEl) {
      regularEl.textContent = priceText;
    }

    if (compareText) {
      var compareEl = stickyPriceRoot.querySelector('.price__compare-price s');
      if (compareEl) compareEl.textContent = compareText;
    }
  }

  function updateStickyAtcVariant(productInfo, variant) {
    if (!variant || !variant.id) return;

    var sectionId = getSectionId(productInfo);
    var picker = document.getElementById('StickyAtcVariantPicker-' + sectionId);
    if (!picker) return;

    var select = picker.querySelector('.variant-dropdown');
    if (!select) return;

    var targetId = String(variant.id);
    var matched =
      select.querySelector('option[data-variant-id="' + targetId + '"]') ||
      Array.prototype.find.call(select.options, function (option) {
        return option.getAttribute('data-variant-id') === targetId;
      });

    if (matched) {
      if (select.value !== matched.value) {
        select.value = matched.value;
      }
      return;
    }

    if (variant.options && variant.options.length) {
      var optionValue = variant.options.join(',');
      if (Array.prototype.some.call(select.options, function (option) {
        return option.value === optionValue;
      })) {
        select.value = optionValue;
      }
      return;
    }

    if (variant.title) {
      Array.prototype.forEach.call(select.options, function (option) {
        if (option.textContent.trim() === variant.title) {
          select.value = option.value;
        }
      });
    }
  }

  function syncProductFormVariant(productInfo, variant) {
    if (!variant || !variant.id) return;

    productInfo.querySelectorAll('product-form input[name="id"]').forEach(function (input) {
      if (String(input.value) !== String(variant.id)) {
        input.value = variant.id;
      }
    });
  }

  /* ---------- Gallery sync ---------- */

  function clickGalleryTarget(gallery, mediaTarget) {
    if (!gallery || !mediaTarget) return false;
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer || !viewer.querySelector('[data-media-id="' + mediaTarget + '"]')) return false;

    var thumb = gallery.querySelector('[data-target="' + mediaTarget + '"] button');
    if (thumb) {
      thumb.click();
      return true;
    }

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(mediaTarget, false);
      return true;
    }
    return false;
  }

  function clickGalleryByImageUrl(productInfo, imageUrl) {
    var key = fileKey(imageUrl);
    if (!key) return false;

    var gallery = productInfo.querySelector('media-gallery');
    if (!gallery) return false;

    var targets = $all('[data-target]', gallery);
    for (var i = 0; i < targets.length; i++) {
      var img = targets[i].querySelector('img');
      if (img && fileKey(img.src) === key) {
        var btn = targets[i].querySelector('button');
        if (btn) {
          btn.click();
          return true;
        }
      }
    }
    return false;
  }

  function clickGalleryByMediaIndex(productInfo, index) {
    var gallery = productInfo.querySelector('media-gallery');
    if (!gallery || typeof index !== 'number') return false;
    var targets = $all('[id^="GalleryThumbnails"] [data-target]', gallery);
    if (!targets[index]) return false;
    var btn = targets[index].querySelector('button');
    if (!btn) return false;
    btn.click();
    return true;
  }

  function getInitialGalleryIndex(productInfo) {
    var raw = productInfo && productInfo.dataset.kachingInitialGalleryIndex;
    var index = parseInt(raw, 10);
    if (isNaN(index) || index < 1) return 0;
    return index - 1;
  }

  function applyInitialGalleryImage(productInfo) {
    if (kachingGalleryUserPicked || !productInfo || !getKachingBlock()) return;
    clickGalleryByMediaIndex(productInfo, getInitialGalleryIndex(productInfo));
  }

  function markKachingGalleryUserPicked() {
    kachingGalleryUserPicked = true;
  }

  function activateGalleryForVariant(productInfo, variant, dealImageSrc) {
    if (!variant) return false;

    var sectionId = getSectionId(productInfo);
    var gallery = productInfo.querySelector('media-gallery');
    if (!gallery) return false;

    var galleryKey =
      String(variant.id) +
      ':' +
      (variant.featured_media_id || '') +
      ':' +
      fileKey(dealImageSrc || variant.featured_image_src || '');
    if (galleryKey === lastGalleryKey) return true;
    lastGalleryKey = galleryKey;

    if (variant.featured_media_id) {
      var mediaTarget = sectionId + '-' + variant.featured_media_id;
      if (clickGalleryTarget(gallery, mediaTarget)) return true;
    }

    if (variant.featured_image_src && clickGalleryByImageUrl(productInfo, variant.featured_image_src)) {
      return true;
    }

    if (dealImageSrc && clickGalleryByImageUrl(productInfo, dealImageSrc)) {
      return true;
    }

    if (typeof variant.media_index === 'number' && clickGalleryByMediaIndex(productInfo, variant.media_index)) {
      return true;
    }

    return false;
  }

  function scheduleGalleryFetch(productInfo, variant) {
    if (!variant || !variant.id || !variant.featured_media_id) return;
    clearTimeout(fetchTimer);
    fetchTimer = setTimeout(function () {
      var sectionId = getSectionId(productInfo);
      var url =
        productInfo.dataset.url +
        '?variant=' +
        variant.id +
        '&section_id=' +
        sectionId;
      fetch(url)
        .then(function (r) {
          return r.text();
        })
        .then(function (htmlText) {
          var html = new DOMParser().parseFromString(htmlText, 'text/html');
          if (typeof productInfo.updateMedia === 'function') {
            productInfo.updateMedia(html, variant.featured_media_id);
          }
        })
        .catch(function () {});
    }, 300);
  }

  function syncFromKaching(event) {
    if (isSyncing) return;
    isSyncing = true;

    try {
      var productInfo = getProductInfo();
      if (!productInfo) return;

      var block = getKachingBlock();
      var variant = resolveVariant(productInfo, event);
      var dealImageSrc = block ? getDealBarImageSrc(block) : null;

      if (variant) {
        syncProductFormVariant(productInfo, variant);
        updateStickyAtcVariant(productInfo, variant);
        if (kachingGalleryUserPicked) {
          var galleryOk = activateGalleryForVariant(productInfo, variant, dealImageSrc);
          if (!galleryOk) scheduleGalleryFetch(productInfo, variant);
        }
      } else if (kachingGalleryUserPicked && dealImageSrc) {
        clickGalleryByImageUrl(productInfo, dealImageSrc);
      }

      if (block) {
        var prices = readKachingPrices(block, event && event.detail);
        if (prices && prices.price) {
          updateDawnPrices(productInfo, prices.price, prices.compare);
        }
      } else if (variant && variant.price_html) {
        updateDawnPrices(
          productInfo,
          String(variant.price_html).replace(/<[^>]+>/g, ''),
          variant.compare_html ? String(variant.compare_html).replace(/<[^>]+>/g, '') : null
        );
      }
    } finally {
      isSyncing = false;
    }
  }

  function scheduleSync(event) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncFromKaching(event);
    }, 120);
  }

  function bindShadowCheckboxWatch(root) {
    if (!root || root.dataset.dsUpsellWatch) return;
    root.dataset.dsUpsellWatch = '1';
    root.addEventListener(
      'change',
      function (e) {
        if (e.target && e.target.matches && e.target.matches('input[type="checkbox"]')) {
          scheduleSync(e);
        }
      },
      true
    );
    root.addEventListener(
      'click',
      function (e) {
        if (
          e.target &&
          e.target.closest &&
          e.target.closest('.kaching-bundles__upsell, [class*="upsell"], [class*="Upsell"]')
        ) {
          scheduleSync(e);
        }
      },
      true
    );
  }

  function isKachingBundlePickEvent(e) {
    if (!e || !e.isTrusted || !e.target || !e.target.closest) return false;
    if (!e.target.closest(KACHING_ROOT)) return false;
    if (e.target.matches && e.target.matches('input[type="radio"]')) return true;
    var label = e.target.closest('label');
    return !!(label && label.querySelector('input[type="radio"]'));
  }

  function bindKachingUserGalleryPick(block) {
    if (!block || block.dataset.dsKachingGalleryPick) return;
    block.dataset.dsKachingGalleryPick = '1';

    function handleUserInput(e) {
      if (isKachingBundlePickEvent(e)) markKachingGalleryUserPicked();
    }

    block.addEventListener('change', handleUserInput, true);
    walkShadowRoots(block, function (node) {
      if (node.shadowRoot) {
        node.shadowRoot.addEventListener('change', handleUserInput, true);
      }
    });
  }

  function bindKachingBlock(block) {
    if (!block || block.dataset.dsKachingBound) return;
    block.dataset.dsKachingBound = 'true';
    KACHING_EVENTS.forEach(function (name) {
      block.addEventListener(name, scheduleSync);
    });
    bindShadowCheckboxWatch(block);
    bindKachingUserGalleryPick(block);
    walkShadowRoots(block, function (node) {
      if (node.shadowRoot) bindShadowCheckboxWatch(node.shadowRoot);
    });
  }

  function bindKaching() {
    $all(KACHING_ROOT).forEach(bindKachingBlock);
  }

  function init() {
    var productInfo = getProductInfo();
    if (!productInfo) return;

    bindKaching();

    if (!getKachingBlock()) {
      [400, 1000, 2500].forEach(function (ms) {
        setTimeout(bindKaching, ms);
      });
      if (typeof MutationObserver !== 'undefined') {
        var obs = new MutationObserver(function () {
          bindKaching();
          if (getKachingBlock()) obs.disconnect();
        });
        obs.observe(document.body, { childList: true, subtree: true });
        setTimeout(function () {
          obs.disconnect();
        }, 8000);
      }
    }

    var variantInput = productInfo.querySelector('product-form input[name="id"]');
    if (variantInput && !variantInput.dataset.dsStickyWatch) {
      variantInput.dataset.dsStickyWatch = 'true';
      variantInput.addEventListener('change', function () {
        var variant = findVariantById(productInfo, variantInput.value);
        if (variant) updateStickyAtcVariant(productInfo, variant);
      });
    }

    scheduleSync(null);

    if (getKachingBlock()) {
      [400, 900, 1600].forEach(function (ms) {
        setTimeout(function () {
          applyInitialGalleryImage(getProductInfo());
        }, ms);
      });
    }
  }

  KACHING_WINDOW_EVENTS.forEach(function (name) {
    window.addEventListener(name, scheduleSync);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      scheduleSync(null);
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      if (isKachingBundlePickEvent(e)) markKachingGalleryUserPicked();
      if (e.target && e.target.closest && e.target.closest(KACHING_ROOT)) {
        scheduleSync(e);
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
